'use strict';
import { module } from '../app';

module.directive('dropTarget', [ '$rootScope', 'uuid', function ($rootScope, uuid) {
  return {
    restrict: 'A',
    // scope: {
    //     onDrop: '&'
    // },uuid
    link: function (scope, el, attrs, controller) {
      function is_touch_device() {
        try {
          document.createEvent("TouchEvent");
          return true;
        } catch (e) {
          return false;
        }
      }

      let id = angular.element(el).attr("id");
      if (!id) {
        id = uuid.new();
        angular.element(el).attr("id", id);
      }
      if (is_touch_device()) {
        webkit_drop.add(el[ 0 ], {
          onOver: function () {
            angular.element(el).addClass('lvl-over');
          },
          onOut: function () {
            angular.element(el).removeClass('lvl-over');
          },
          onDrop: function (obj, e) {
            scope.$apply(function () {
              try {
                scope.$eval(attrs.onDrop)(obj, {
                  x: e.changedTouches[ 0 ].clientX - el[ 0 ].getBoundingClientRect().left,
                  y: e.changedTouches[ 0 ].clientY - el[ 0 ].getBoundingClientRect().top
                });
              }
              catch (ex) {
                alert(ex);
              }
            });


            //scope.$digest();
            scope.$apply();
          }
        });
      }
      else {

        el.bind("dragover", function (e) {
          if (e.preventDefault) {
            e.preventDefault(); // Necessary. Allows us to drop.
          }

          if (e.stopPropagation) {
            e.stopPropagation();
          }

          if (!!e.dataTransfer) {
            e.dataTransfer.dropEffect = 'move';
          }
          else if (!!e.originalEvent.dataTransfer) {
            e.originalEvent.dataTransfer.dropEffect = 'move';
          }
          return false;
        });

        el.bind("dragenter", function (e) {
          angular.element(el).addClass('lvl-over');
        });

        el.bind("dragleave", function (e) {
          angular.element(el).removeClass('lvl-over');  // this / e.target is previous target element.
        });
        el.bind("drop", function (e) {
          if (!!e.preventDefault) {
            e.preventDefault(); // Necessary. Allows us to drop.
          }

          if (!!e.stopPropogation) {
            e.stopPropogation(); // Necessary. Allows us to drop.
          }

          let data;

          if (!!e.dataTransfer) {
            data = e.dataTransfer.getData("text");
          } else if (!!e.originalEvent.dataTransfer) {
            data = e.originalEvent.dataTransfer.getData("text");
          } else {
            data = $(e.target).data('text');
          }

          let dest = document.getElementById(id);
          let src = document.getElementById(data);
          angular.element(el).removeClass("lvl-target");
          angular.element(el).removeClass("lvl-over");
          scope.$apply(function () {
            // scope.$eval(attrs.onDrop)(src, {x: e.clientX, y: e.clientY});

            scope.$eval(attrs.onDrop)(src, {
              x: e.clientX - el[ 0 ].getBoundingClientRect().left,
              y: e.clientY - el[ 0 ].getBoundingClientRect().top
            });
          });
        });
      }
      $rootScope.$on("LVL-DRAG-START", function () {
        let el = document.getElementById(id);
        angular.element(el).addClass("lvl-target");
      });

      $rootScope.$on("LVL-DRAG-END", function () {
        let el = document.getElementById(id);
        angular.element(el).removeClass("lvl-target");
        angular.element(el).removeClass("lvl-over");
      });
    }
  };
} ]);



// WEBPACK FOOTER //
// ./src/scripts/directives/dropTarget.js